module.exports = __webpack_public_path__ + "static/glean-mobile-bbecb718a30c38720512b3ebd669f631.png";